/**
 * Russian profanity data
 * Auto-generated from JSON files - DO NOT EDIT MANUALLY
 *
 * Language: Russian
 * Version: 1.0.0
 * Last Updated: 2025-09-30
 * Total Entries: 215
 */

export const RU = {
  "metadata": {
    "name": "Russian",
    "code": "ru",
    "version": "1.0.0",
    "lastUpdated": "2025-09-30",
    "wordCount": 215
  },
  "words": [
    {
      "word": "блядь",
      "severity": 3,
      "categories": [
        "mat_system",
        "sexual",
        "general"
      ],
      "variations": [
        "блядка",
        "бля",
        "блять",
        "b||ad",
        "bl@d",
        "блпдь",
        "blyat",
        "blyat'"
      ],
      "case_sensitive": false,
      "context_notes": "Core mat word, extremely common in Russian internet culture, used as intensifier",
      "target_type": "general"
    },
    {
      "word": "сука",
      "severity": 3,
      "categories": [
        "mat_system",
        "derogatory",
        "gender"
      ],
      "variations": [
        "сучка",
        "сук",
        "cvka",
        "cyka",
        "сvка",
        "с_ка",
        "syk@"
      ],
      "case_sensitive": false,
      "context_notes": "Very common mat word, literally 'bitch', used for both genders in modern usage",
      "target_type": "individual"
    },
    {
      "word": "пиздец",
      "severity": 3,
      "categories": [
        "mat_system",
        "general",
        "sexual"
      ],
      "variations": [
        "пздц",
        "пиздос",
        "пиздеж",
        "pizdec",
        "pzdts",
        "п-ц"
      ],
      "case_sensitive": false,
      "context_notes": "Mat expression meaning disaster/end, very commonly used as exclamation",
      "target_type": "general"
    },
    {
      "word": "хуй",
      "severity": 4,
      "categories": [
        "mat_system",
        "sexual",
        "anatomical"
      ],
      "variations": [
        "хер",
        "хрен",
        "х_й",
        "huy",
        "hui",
        "х-й",
        "xyй"
      ],
      "case_sensitive": false,
      "context_notes": "Strongest mat word, male genitalia, used in many compound expressions",
      "target_type": "general"
    },
    {
      "word": "ебать",
      "severity": 4,
      "categories": [
        "mat_system",
        "sexual",
        "violence"
      ],
      "variations": [
        "ебал",
        "ебёт",
        "еб",
        "ebat'",
        "jebat",
        "е6ать",
        "ебнуть"
      ],
      "case_sensitive": false,
      "context_notes": "Strong mat verb, sexual/violent connotations, basis for many expressions",
      "target_type": "general"
    },
    {
      "word": "пизда",
      "severity": 4,
      "categories": [
        "mat_system",
        "sexual",
        "anatomical"
      ],
      "variations": [
        "пизд",
        "писька",
        "pizda",
        "p1zda",
        "пздa",
        "п-да"
      ],
      "case_sensitive": false,
      "context_notes": "Female genitalia, part of core mat vocabulary, used in many expressions",
      "target_type": "general"
    },
    {
      "word": "говно",
      "severity": 2,
      "categories": [
        "scatological",
        "general"
      ],
      "variations": [
        "гавно",
        "г*вно",
        "govno",
        "gavno",
        "гoвно"
      ],
      "case_sensitive": false,
      "context_notes": "Common scatological term, widely used as general insult",
      "target_type": "general"
    },
    {
      "word": "дерьмо",
      "severity": 2,
      "categories": [
        "scatological",
        "general"
      ],
      "variations": [
        "дерьмеце",
        "дермо",
        "der'mo",
        "дepьmo",
        "д*рьмо"
      ],
      "case_sensitive": false,
      "context_notes": "Scatological term, less intense than mat words but still vulgar",
      "target_type": "general"
    },
    {
      "word": "жопа",
      "severity": 2,
      "categories": [
        "anatomical",
        "general"
      ],
      "variations": [
        "жоп",
        "жопка",
        "zhopa",
        "zopa",
        "ж*па",
        "жoпa"
      ],
      "case_sensitive": false,
      "context_notes": "Buttocks, common vulgar term, relatively mild compared to mat",
      "target_type": "general"
    },
    {
      "word": "мудак",
      "severity": 3,
      "categories": [
        "derogatory",
        "male_specific"
      ],
      "variations": [
        "мудачок",
        "мудачина",
        "mudak",
        "mydak",
        "м_дак"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term for males, related to male genitalia slang",
      "target_type": "individual"
    },
    {
      "word": "козёл",
      "severity": 2,
      "categories": [
        "derogatory",
        "general"
      ],
      "variations": [
        "козлина",
        "козлище",
        "kozel",
        "k0zel",
        "кoзёл"
      ],
      "case_sensitive": false,
      "context_notes": "Literally goat, common insult implying stupidity or stubbornness",
      "target_type": "individual"
    },
    {
      "word": "сволочь",
      "severity": 3,
      "categories": [
        "derogatory",
        "general"
      ],
      "variations": [
        "сволочь",
        "сволота",
        "svoloch'",
        "св*лочь",
        "сволoчь"
      ],
      "case_sensitive": false,
      "context_notes": "Strong derogatory term, implies moral corruption",
      "target_type": "individual"
    },
    {
      "word": "гад",
      "severity": 2,
      "categories": [
        "derogatory",
        "general"
      ],
      "variations": [
        "гадина",
        "гадюка",
        "gad",
        "g@d",
        "гaд"
      ],
      "case_sensitive": false,
      "context_notes": "Literally reptile, used as general insult",
      "target_type": "individual"
    },
    {
      "word": "падла",
      "severity": 2,
      "categories": [
        "derogatory",
        "general"
      ],
      "variations": [
        "падаль",
        "падлюка",
        "padla",
        "p@dla",
        "пaдла"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term implying moral decay, literally carrion",
      "target_type": "individual"
    },
    {
      "word": "урод",
      "severity": 2,
      "categories": [
        "derogatory",
        "appearance"
      ],
      "variations": [
        "уродина",
        "уродище",
        "urod",
        "yr0d",
        "урoд"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term about appearance, literally freak/monster",
      "target_type": "individual"
    },
    {
      "word": "дура",
      "severity": 1,
      "categories": [
        "derogatory",
        "female_specific"
      ],
      "variations": [
        "дурища",
        "дурочка",
        "dura",
        "dyra",
        "дypa"
      ],
      "case_sensitive": false,
      "context_notes": "Mild insult for females, implies stupidity",
      "target_type": "individual"
    },
    {
      "word": "дурак",
      "severity": 1,
      "categories": [
        "derogatory",
        "general"
      ],
      "variations": [
        "дурачок",
        "дурачина",
        "durak",
        "dyrak",
        "дypaк"
      ],
      "case_sensitive": false,
      "context_notes": "Common mild insult, implies foolishness",
      "target_type": "individual"
    },
    {
      "word": "идиот",
      "severity": 2,
      "categories": [
        "derogatory",
        "general"
      ],
      "variations": [
        "идиотка",
        "идиотина",
        "idiot",
        "1diot",
        "идиoт"
      ],
      "case_sensitive": false,
      "context_notes": "Strong insult implying mental deficiency",
      "target_type": "individual"
    },
    {
      "word": "дебил",
      "severity": 2,
      "categories": [
        "derogatory",
        "ableist"
      ],
      "variations": [
        "дебилка",
        "дебилоид",
        "debil",
        "d3bil",
        "дeбил"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term with medical origins, now general insult",
      "target_type": "individual"
    },
    {
      "word": "шлюха",
      "severity": 3,
      "categories": [
        "sexual",
        "female_specific",
        "derogatory"
      ],
      "variations": [
        "шлюшка",
        "шлюха",
        "shlyuha",
        "shl@ha",
        "шлюxа"
      ],
      "case_sensitive": false,
      "context_notes": "Strong sexual insult for women, implies promiscuity",
      "target_type": "individual"
    },
    {
      "word": "курва",
      "severity": 3,
      "categories": [
        "sexual",
        "female_specific",
        "borrowed"
      ],
      "variations": [
        "курба",
        "курвище",
        "kurva",
        "kyrva",
        "кypвa"
      ],
      "case_sensitive": false,
      "context_notes": "Borrowed from Polish, sexual insult for women. Cyrillic: курва, Latin: kurva",
      "target_type": "individual"
    },
    {
      "word": "авексдо",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "aveksdo"
      ],
      "case_sensitive": false,
      "context_notes": "Mild exclamation. Cyrillic: авексдо, Latin: aveksdo",
      "target_type": "general"
    },
    {
      "word": "аборт",
      "severity": 2,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "abort"
      ],
      "case_sensitive": false,
      "context_notes": "Abortion used as insult. Cyrillic: аборт, Latin: abort",
      "target_type": "individual"
    },
    {
      "word": "баба",
      "severity": 1,
      "categories": [
        "derogatory",
        "female_specific"
      ],
      "variations": [
        "baba"
      ],
      "case_sensitive": false,
      "context_notes": "Woman (can be derogatory). Cyrillic: баба, Latin: baba",
      "target_type": "individual"
    },
    {
      "word": "бздёнок",
      "severity": 2,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "бздёнок",
        "bzdyonok"
      ],
      "case_sensitive": false,
      "context_notes": "Little fart/coward. Cyrillic: бздёнок, Latin: bzdyonok",
      "target_type": "individual"
    },
    {
      "word": "блатной",
      "severity": 2,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "blatnoy"
      ],
      "case_sensitive": false,
      "context_notes": "Criminal/gangster. Cyrillic: блатной, Latin: blatnoy",
      "target_type": "individual"
    },
    {
      "word": "блевать",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "blevat'",
        "blevat"
      ],
      "case_sensitive": false,
      "context_notes": "To vomit. Cyrillic: блевать, Latin: blevat'",
      "target_type": "general"
    },
    {
      "word": "блин",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "blin"
      ],
      "case_sensitive": false,
      "context_notes": "Damn (euphemism for blyad'). Cyrillic: блин, Latin: blin",
      "target_type": "general"
    },
    {
      "word": "блядки",
      "severity": 3,
      "categories": [
        "mat_system",
        "sexual"
      ],
      "variations": [
        "blyadki"
      ],
      "case_sensitive": false,
      "context_notes": "Little whores (diminutive of blyad'). Cyrillic: блядки, Latin: blyadki",
      "target_type": "general"
    },
    {
      "word": "блядовать",
      "severity": 3,
      "categories": [
        "mat_system",
        "sexual"
      ],
      "variations": [
        "blyadovat'"
      ],
      "case_sensitive": false,
      "context_notes": "To whore around (from blyad'). Cyrillic: блядовать, Latin: blyadovat'",
      "target_type": "general"
    },
    {
      "word": "блядство",
      "severity": 3,
      "categories": [
        "mat_system",
        "sexual"
      ],
      "variations": [
        "blyadstvo"
      ],
      "case_sensitive": false,
      "context_notes": "Whoring/debauchery (from blyad'). Cyrillic: блядство, Latin: blyadstvo",
      "target_type": "general"
    },
    {
      "word": "блядун",
      "severity": 3,
      "categories": [
        "mat_system",
        "sexual",
        "male_specific"
      ],
      "variations": [
        "blyadun"
      ],
      "case_sensitive": false,
      "context_notes": "Male whore (from blyad'). Cyrillic: блядун, Latin: blyadun",
      "target_type": "individual"
    },
    {
      "word": "бугор",
      "severity": 2,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "bugor"
      ],
      "case_sensitive": false,
      "context_notes": "Criminal boss. Cyrillic: бугор, Latin: bugor",
      "target_type": "individual"
    },
    {
      "word": "вафлер",
      "severity": 2,
      "categories": [
        "sexual",
        "derogatory"
      ],
      "variations": [
        "vafler"
      ],
      "case_sensitive": false,
      "context_notes": "Cocksucker (from gaming). Cyrillic: вафлер, Latin: vafler",
      "target_type": "individual"
    },
    {
      "word": "вздроченный",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "vzdrochennyi"
      ],
      "case_sensitive": false,
      "context_notes": "Jerked off/exhausted. Cyrillic: вздроченный, Latin: vzdrochennyi",
      "target_type": "general"
    },
    {
      "word": "выблядок",
      "severity": 3,
      "categories": [
        "mat_system",
        "derogatory"
      ],
      "variations": [
        "vyblyad ok",
        "vyblyadok"
      ],
      "case_sensitive": false,
      "context_notes": "Bastard (from blyad'). Cyrillic: выблядок, Latin: vyblyad ok",
      "target_type": "individual"
    },
    {
      "word": "выёбываться",
      "severity": 4,
      "categories": [
        "mat_system",
        "sexual"
      ],
      "variations": [
        "vyobyvatsia"
      ],
      "case_sensitive": false,
      "context_notes": "To show off (from yebat'). Cyrillic: выёбываться, Latin: vyobyvatsia",
      "target_type": "general"
    },
    {
      "word": "выпердыш",
      "severity": 2,
      "categories": [
        "scatological",
        "derogatory"
      ],
      "variations": [
        "vyperdysh"
      ],
      "case_sensitive": false,
      "context_notes": "Fart/insignificant person. Cyrillic: выпердыш, Latin: vyperdysh",
      "target_type": "individual"
    },
    {
      "word": "гадина",
      "severity": 2,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "gadina"
      ],
      "case_sensitive": false,
      "context_notes": "Reptile/scumbag (augmentative of gad). Cyrillic: гадина, Latin: gadina",
      "target_type": "individual"
    },
    {
      "word": "гандон",
      "severity": 3,
      "categories": [
        "sexual",
        "derogatory"
      ],
      "variations": [
        "gandon"
      ],
      "case_sensitive": false,
      "context_notes": "Condom/asshole. Cyrillic: гандон, Latin: gandon",
      "target_type": "individual"
    },
    {
      "word": "гнида",
      "severity": 2,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "gnida"
      ],
      "case_sensitive": false,
      "context_notes": "Nit/scum. Cyrillic: гнида, Latin: gnida",
      "target_type": "individual"
    },
    {
      "word": "говнюк",
      "severity": 2,
      "categories": [
        "scatological",
        "derogatory"
      ],
      "variations": [
        "govnyuk"
      ],
      "case_sensitive": false,
      "context_notes": "Shitty person. Cyrillic: говнюк, Latin: govnyuk",
      "target_type": "individual"
    },
    {
      "word": "говнище",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "govnishche"
      ],
      "case_sensitive": false,
      "context_notes": "Big shit (augmentative). Cyrillic: говнище, Latin: govnishche",
      "target_type": "general"
    },
    {
      "word": "голубой",
      "severity": 2,
      "categories": [
        "slurs"
      ],
      "variations": [
        "goluboy"
      ],
      "case_sensitive": false,
      "context_notes": "Blue/gay (euphemism). Cyrillic: голубой, Latin: goluboy",
      "target_type": "individual"
    },
    {
      "word": "дебилка",
      "severity": 2,
      "categories": [
        "derogatory",
        "ableist",
        "female_specific"
      ],
      "variations": [
        "debilka"
      ],
      "case_sensitive": false,
      "context_notes": "Female retard. Cyrillic: дебилка, Latin: debilka",
      "target_type": "individual"
    },
    {
      "word": "дебилоид",
      "severity": 2,
      "categories": [
        "derogatory",
        "ableist"
      ],
      "variations": [
        "debiloid"
      ],
      "case_sensitive": false,
      "context_notes": "Retarded person (internet slang). Cyrillic: дебилоид, Latin: debiloid",
      "target_type": "individual"
    },
    {
      "word": "дерьмеце",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "der'metse"
      ],
      "case_sensitive": false,
      "context_notes": "Little shit (diminutive). Cyrillic: дерьмеце, Latin: der'metse",
      "target_type": "general"
    },
    {
      "word": "дерьмина",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "der'mina"
      ],
      "case_sensitive": false,
      "context_notes": "Big shit (augmentative). Cyrillic: дерьмина, Latin: der'mina",
      "target_type": "general"
    },
    {
      "word": "долбоёб",
      "severity": 4,
      "categories": [
        "mat_system",
        "derogatory"
      ],
      "variations": [
        "dolboyob"
      ],
      "case_sensitive": false,
      "context_notes": "Fucking idiot (from yebat'). Cyrillic: долбоёб, Latin: dolboyob",
      "target_type": "individual"
    },
    {
      "word": "дрочить",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "drochit'"
      ],
      "case_sensitive": false,
      "context_notes": "To masturbate. Cyrillic: дрочить, Latin: drochit'",
      "target_type": "general"
    },
    {
      "word": "дрочер",
      "severity": 3,
      "categories": [
        "sexual",
        "derogatory"
      ],
      "variations": [
        "drocher"
      ],
      "case_sensitive": false,
      "context_notes": "Masturbator/wanker. Cyrillic: дрочер, Latin: drocher",
      "target_type": "individual"
    },
    {
      "word": "дурачок",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "durachok"
      ],
      "case_sensitive": false,
      "context_notes": "Little fool (diminutive). Cyrillic: дурачок, Latin: durachok",
      "target_type": "individual"
    },
    {
      "word": "ебало",
      "severity": 4,
      "categories": [
        "mat_system",
        "anatomical"
      ],
      "variations": [
        "ebalo"
      ],
      "case_sensitive": false,
      "context_notes": "Face/mug (from yebat'). Cyrillic: ебало, Latin: ebalo",
      "target_type": "general"
    },
    {
      "word": "ебальник",
      "severity": 4,
      "categories": [
        "mat_system",
        "anatomical"
      ],
      "variations": [
        "ebal'nik"
      ],
      "case_sensitive": false,
      "context_notes": "Face/mug (from yebat'). Cyrillic: ебальник, Latin: ebal'nik",
      "target_type": "general"
    },
    {
      "word": "ебануть",
      "severity": 4,
      "categories": [
        "mat_system",
        "violence"
      ],
      "variations": [
        "ebanut'"
      ],
      "case_sensitive": false,
      "context_notes": "To fuck/to hit (from yebat'). Cyrillic: ебануть, Latin: ebanut'",
      "target_type": "general"
    },
    {
      "word": "ебанутый",
      "severity": 4,
      "categories": [
        "mat_system",
        "derogatory"
      ],
      "variations": [
        "ebanutyj"
      ],
      "case_sensitive": false,
      "context_notes": "Fucked up/crazy (from yebat'). Cyrillic: ебанутый, Latin: ebanutyj",
      "target_type": "individual"
    },
    {
      "word": "ебарь",
      "severity": 4,
      "categories": [
        "mat_system",
        "sexual"
      ],
      "variations": [
        "ebar'"
      ],
      "case_sensitive": false,
      "context_notes": "Fucker (from yebat'). Cyrillic: ебарь, Latin: ebar'",
      "target_type": "individual"
    },
    {
      "word": "ебашить",
      "severity": 4,
      "categories": [
        "mat_system",
        "violence"
      ],
      "variations": [
        "ebashit'"
      ],
      "case_sensitive": false,
      "context_notes": "To fuck/to work hard (from yebat'). Cyrillic: ебашить, Latin: ebashit'",
      "target_type": "general"
    },
    {
      "word": "ебло",
      "severity": 4,
      "categories": [
        "mat_system",
        "anatomical"
      ],
      "variations": [
        "eblo"
      ],
      "case_sensitive": false,
      "context_notes": "Face/mug (from yebat'). Cyrillic: ебло, Latin: eblo",
      "target_type": "general"
    },
    {
      "word": "ебнуть",
      "severity": 4,
      "categories": [
        "mat_system",
        "violence"
      ],
      "variations": [
        "ebnut'"
      ],
      "case_sensitive": false,
      "context_notes": "To fuck/to hit (from yebat'). Cyrillic: ебнуть, Latin: ebnut'",
      "target_type": "general"
    },
    {
      "word": "ебнуться",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "ebnut'sya"
      ],
      "case_sensitive": false,
      "context_notes": "To go crazy (reflexive from yebat'). Cyrillic: ебнуться, Latin: ebnut'sya",
      "target_type": "general"
    },
    {
      "word": "жопка",
      "severity": 2,
      "categories": [
        "anatomical"
      ],
      "variations": [
        "zhopka"
      ],
      "case_sensitive": false,
      "context_notes": "Little ass (diminutive). Cyrillic: жопка, Latin: zhopka",
      "target_type": "general"
    },
    {
      "word": "жополиз",
      "severity": 2,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "zhopoliz"
      ],
      "case_sensitive": false,
      "context_notes": "Ass-licker/brown-noser. Cyrillic: жополиз, Latin: zhopoliz",
      "target_type": "individual"
    },
    {
      "word": "жопище",
      "severity": 2,
      "categories": [
        "anatomical"
      ],
      "variations": [
        "zhopishche"
      ],
      "case_sensitive": false,
      "context_notes": "Big ass (augmentative). Cyrillic: жопище, Latin: zhopishche",
      "target_type": "general"
    },
    {
      "word": "заебать",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "zaebat'"
      ],
      "case_sensitive": false,
      "context_notes": "To fuck up/to tire out (from yebat'). Cyrillic: заебать, Latin: zaebat'",
      "target_type": "general"
    },
    {
      "word": "заебаться",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "zaebat'sya"
      ],
      "case_sensitive": false,
      "context_notes": "To be fucked/exhausted (from yebat'). Cyrillic: заебаться, Latin: zaebat'sya",
      "target_type": "general"
    },
    {
      "word": "заебись",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "zaebis'"
      ],
      "case_sensitive": false,
      "context_notes": "Fucking awesome (from yebat'). Cyrillic: заебись, Latin: zaebis'",
      "target_type": "general"
    },
    {
      "word": "залупа",
      "severity": 4,
      "categories": [
        "mat_system",
        "anatomical"
      ],
      "variations": [
        "zalupa"
      ],
      "case_sensitive": false,
      "context_notes": "Dick head (from khuy root). Cyrillic: залупа, Latin: zalupa",
      "target_type": "general"
    },
    {
      "word": "залупать",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "zalupat'"
      ],
      "case_sensitive": false,
      "context_notes": "Related to dick (from khuy root). Cyrillic: залупать, Latin: zalupat'",
      "target_type": "general"
    },
    {
      "word": "засать",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "zasat'"
      ],
      "case_sensitive": false,
      "context_notes": "To piss on. Cyrillic: засать, Latin: zasat'",
      "target_type": "general"
    },
    {
      "word": "засранец",
      "severity": 2,
      "categories": [
        "scatological",
        "derogatory"
      ],
      "variations": [
        "zasranets"
      ],
      "case_sensitive": false,
      "context_notes": "Shitty person/coward. Cyrillic: засранец, Latin: zasranets",
      "target_type": "individual"
    },
    {
      "word": "заёбать",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "zayobat'"
      ],
      "case_sensitive": false,
      "context_notes": "Variant of zaebat'. Cyrillic: заёбать, Latin: zayobat'",
      "target_type": "general"
    },
    {
      "word": "идиотка",
      "severity": 2,
      "categories": [
        "derogatory",
        "female_specific"
      ],
      "variations": [
        "idiotka"
      ],
      "case_sensitive": false,
      "context_notes": "Female idiot. Cyrillic: идиотка, Latin: idiotka",
      "target_type": "individual"
    },
    {
      "word": "идиотина",
      "severity": 2,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "idiotina"
      ],
      "case_sensitive": false,
      "context_notes": "Big idiot (augmentative). Cyrillic: идиотина, Latin: idiotina",
      "target_type": "individual"
    },
    {
      "word": "измудохать",
      "severity": 3,
      "categories": [
        "violence"
      ],
      "variations": [
        "izmudohat'"
      ],
      "case_sensitive": false,
      "context_notes": "To beat up (from muda root). Cyrillic: измудохать, Latin: izmudohat'",
      "target_type": "individual"
    },
    {
      "word": "козлина",
      "severity": 2,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "kozlina"
      ],
      "case_sensitive": false,
      "context_notes": "Big goat (augmentative). Cyrillic: козлина, Latin: kozlina",
      "target_type": "individual"
    },
    {
      "word": "кретин",
      "severity": 2,
      "categories": [
        "derogatory",
        "ableist"
      ],
      "variations": [
        "kretin"
      ],
      "case_sensitive": false,
      "context_notes": "Cretin/moron. Cyrillic: кретин, Latin: kretin",
      "target_type": "individual"
    },
    {
      "word": "малафья",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "malafia"
      ],
      "case_sensitive": false,
      "context_notes": "Sperm (slang). Cyrillic: малафья, Latin: malafia",
      "target_type": "general"
    },
    {
      "word": "манда",
      "severity": 4,
      "categories": [
        "mat_system",
        "sexual",
        "anatomical"
      ],
      "variations": [
        "manda"
      ],
      "case_sensitive": false,
      "context_notes": "Pussy (variant of pizda). Cyrillic: манда, Latin: manda",
      "target_type": "general"
    },
    {
      "word": "мандавошка",
      "severity": 3,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "mandavoshka"
      ],
      "case_sensitive": false,
      "context_notes": "Crab louse/scumbag. Cyrillic: мандавошка, Latin: mandavoshka",
      "target_type": "individual"
    },
    {
      "word": "мент",
      "severity": 2,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "ment"
      ],
      "case_sensitive": false,
      "context_notes": "Cop (derogatory). Cyrillic: мент, Latin: ment",
      "target_type": "individual"
    },
    {
      "word": "мерзавец",
      "severity": 2,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "merzavets"
      ],
      "case_sensitive": false,
      "context_notes": "Scoundrel/bastard. Cyrillic: мерзавец, Latin: merzavets",
      "target_type": "individual"
    },
    {
      "word": "муда",
      "severity": 3,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "muda"
      ],
      "case_sensitive": false,
      "context_notes": "Testicles (archaic). Cyrillic: муда, Latin: muda",
      "target_type": "general"
    },
    {
      "word": "мудачина",
      "severity": 3,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "mudachina"
      ],
      "case_sensitive": false,
      "context_notes": "Big asshole (augmentative from muda). Cyrillic: мудачина, Latin: mudachina",
      "target_type": "individual"
    },
    {
      "word": "мудачок",
      "severity": 3,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "mudachok"
      ],
      "case_sensitive": false,
      "context_notes": "Little asshole (diminutive from muda). Cyrillic: мудачок, Latin: mudachok",
      "target_type": "individual"
    },
    {
      "word": "мудило",
      "severity": 3,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "mudilo"
      ],
      "case_sensitive": false,
      "context_notes": "Asshole (from muda). Cyrillic: мудило, Latin: mudilo",
      "target_type": "individual"
    },
    {
      "word": "мудозвон",
      "severity": 3,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "mudozvon"
      ],
      "case_sensitive": false,
      "context_notes": "Annoying person (literally 'ball-ringer'). Cyrillic: мудозвон, Latin: mudozvon",
      "target_type": "individual"
    },
    {
      "word": "наебать",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "naebat'"
      ],
      "case_sensitive": false,
      "context_notes": "To fuck over/deceive (from yebat'). Cyrillic: наебать, Latin: naebat'",
      "target_type": "general"
    },
    {
      "word": "наебениться",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "naebenitsya"
      ],
      "case_sensitive": false,
      "context_notes": "To get drunk (from yebat'). Cyrillic: наебениться, Latin: naebenitsya",
      "target_type": "general"
    },
    {
      "word": "наебнуться",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "naebnut'sya"
      ],
      "case_sensitive": false,
      "context_notes": "To fall/crash (from yebat'). Cyrillic: наебнуться, Latin: naebnut'sya",
      "target_type": "general"
    },
    {
      "word": "нахуй",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "nahuy",
        "nahui"
      ],
      "case_sensitive": false,
      "context_notes": "To dick/fuck off (from khuy). Cyrillic: нахуй, Latin: nahuy",
      "target_type": "general"
    },
    {
      "word": "нахуячиться",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "nahuyachit'sya"
      ],
      "case_sensitive": false,
      "context_notes": "To get wasted (from khuy). Cyrillic: нахуячиться, Latin: nahuyachit'sya",
      "target_type": "general"
    },
    {
      "word": "невебенный",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "nevebennyj"
      ],
      "case_sensitive": false,
      "context_notes": "Incredible (from yebat'). Cyrillic: невебенный, Latin: nevebennyj",
      "target_type": "general"
    },
    {
      "word": "обнаженный",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "obnazhennyi"
      ],
      "case_sensitive": false,
      "context_notes": "Naked (mild). Cyrillic: обнаженный, Latin: obnazhennyi",
      "target_type": "general"
    },
    {
      "word": "опесдол",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "opesdol"
      ],
      "case_sensitive": false,
      "context_notes": "Variant of opizdet (from pizda). Cyrillic: опесдол, Latin: opesdol",
      "target_type": "general"
    },
    {
      "word": "опизденеть",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "opizdenet'"
      ],
      "case_sensitive": false,
      "context_notes": "To be shocked (from pizda). Cyrillic: опизденеть, Latin: opizdenet'",
      "target_type": "general"
    },
    {
      "word": "остохуительно",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "ostohuitel'no"
      ],
      "case_sensitive": false,
      "context_notes": "Fucking amazing (from khuy). Cyrillic: остохуительно, Latin: ostohuitel'no",
      "target_type": "general"
    },
    {
      "word": "остоёбло",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "ostoyoblo"
      ],
      "case_sensitive": false,
      "context_notes": "Got bored (from yebat'). Cyrillic: остоёбло, Latin: ostoyoblo",
      "target_type": "general"
    },
    {
      "word": "отмудохать",
      "severity": 3,
      "categories": [
        "violence"
      ],
      "variations": [
        "otmudohat'"
      ],
      "case_sensitive": false,
      "context_notes": "To beat up (from muda). Cyrillic: отмудохать, Latin: otmudohat'",
      "target_type": "individual"
    },
    {
      "word": "отпиздить",
      "severity": 4,
      "categories": [
        "mat_system",
        "violence"
      ],
      "variations": [
        "otpizdit'"
      ],
      "case_sensitive": false,
      "context_notes": "To beat up (from pizda). Cyrillic: отпиздить, Latin: otpizdit'",
      "target_type": "individual"
    },
    {
      "word": "отсоси",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "otsosi"
      ],
      "case_sensitive": false,
      "context_notes": "Suck (dick) - imperative. Cyrillic: отсоси, Latin: otsosi",
      "target_type": "individual"
    },
    {
      "word": "отъебись",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "otyobis'"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck off (from yebat'). Cyrillic: отъебись, Latin: otyobis'",
      "target_type": "individual"
    },
    {
      "word": "охуеть",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "ohuet'"
      ],
      "case_sensitive": false,
      "context_notes": "To be shocked/amazed (from khuy). Cyrillic: охуеть, Latin: ohuet'",
      "target_type": "general"
    },
    {
      "word": "охуительно",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "ohuitel'no"
      ],
      "case_sensitive": false,
      "context_notes": "Fucking amazing (from khuy). Cyrillic: охуительно, Latin: ohuitel'no",
      "target_type": "general"
    },
    {
      "word": "падло",
      "severity": 2,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "padlo"
      ],
      "case_sensitive": false,
      "context_notes": "Scumbag/bastard. Cyrillic: падло, Latin: padlo",
      "target_type": "individual"
    },
    {
      "word": "педераст",
      "severity": 3,
      "categories": [
        "slurs",
        "hate_speech"
      ],
      "variations": [
        "pederast"
      ],
      "case_sensitive": false,
      "context_notes": "Pederast/faggot (homophobic slur). Cyrillic: педераст, Latin: pederast",
      "target_type": "individual"
    },
    {
      "word": "педик",
      "severity": 3,
      "categories": [
        "slurs",
        "hate_speech"
      ],
      "variations": [
        "pedik"
      ],
      "case_sensitive": false,
      "context_notes": "Faggot (homophobic slur). Cyrillic: педик, Latin: pedik",
      "target_type": "individual"
    },
    {
      "word": "пердеть",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "perdet'"
      ],
      "case_sensitive": false,
      "context_notes": "To fart. Cyrillic: пердеть, Latin: perdet'",
      "target_type": "general"
    },
    {
      "word": "пердун",
      "severity": 2,
      "categories": [
        "scatological",
        "derogatory"
      ],
      "variations": [
        "perdun"
      ],
      "case_sensitive": false,
      "context_notes": "Farter. Cyrillic: пердун, Latin: perdun",
      "target_type": "individual"
    },
    {
      "word": "пиздато",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "pizdato"
      ],
      "case_sensitive": false,
      "context_notes": "Fucking great (from pizda). Cyrillic: пиздато, Latin: pizdato",
      "target_type": "general"
    },
    {
      "word": "пиздатый",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "pizdatyj"
      ],
      "case_sensitive": false,
      "context_notes": "Fucking awesome (from pizda). Cyrillic: пиздатый, Latin: pizdatyj",
      "target_type": "general"
    },
    {
      "word": "пиздёнка",
      "severity": 4,
      "categories": [
        "mat_system",
        "sexual"
      ],
      "variations": [
        "pizdyonka"
      ],
      "case_sensitive": false,
      "context_notes": "Little pussy (diminutive from pizda). Cyrillic: пиздёнка, Latin: pizdyonka",
      "target_type": "general"
    },
    {
      "word": "пиздет",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "pizdet"
      ],
      "case_sensitive": false,
      "context_notes": "To lie (from pizda). Cyrillic: пиздет, Latin: pizdet",
      "target_type": "general"
    },
    {
      "word": "пиздеж",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "pizdzh"
      ],
      "case_sensitive": false,
      "context_notes": "Lies/bullshit (from pizda). Cyrillic: пиздеж, Latin: pizdzh",
      "target_type": "general"
    },
    {
      "word": "пиздить",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "pizdit'"
      ],
      "case_sensitive": false,
      "context_notes": "To steal/to lie (from pizda). Cyrillic: пиздить, Latin: pizdit'",
      "target_type": "general"
    },
    {
      "word": "пиздиук",
      "severity": 4,
      "categories": [
        "mat_system",
        "derogatory"
      ],
      "variations": [
        "pizdiuk"
      ],
      "case_sensitive": false,
      "context_notes": "Little fucker (from pizda). Cyrillic: пиздиук, Latin: pizdiuk",
      "target_type": "individual"
    },
    {
      "word": "пиздобратия",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "pizdobratia"
      ],
      "case_sensitive": false,
      "context_notes": "Pussy brotherhood (from pizda). Cyrillic: пиздобратия, Latin: pizdobratia",
      "target_type": "general"
    },
    {
      "word": "пиздоглазый",
      "severity": 4,
      "categories": [
        "mat_system",
        "slurs",
        "hate_speech"
      ],
      "variations": [
        "pizdoglazyi"
      ],
      "case_sensitive": false,
      "context_notes": "Pussy-eyed (ethnic slur, from pizda). Cyrillic: пиздоглазый, Latin: pizdoglazyi",
      "target_type": "individual"
    },
    {
      "word": "пиздопрошибательный",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "pizdoproshihatel'nyi"
      ],
      "case_sensitive": false,
      "context_notes": "Mind-blowing (from pizda). Cyrillic: пиздопрошибательный, Latin: pizdoproshihatel'nyi",
      "target_type": "general"
    },
    {
      "word": "пиздопроёбина",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "pizdoproyobina"
      ],
      "case_sensitive": false,
      "context_notes": "Fucking mess (compound mat from pizda+yebat'). Cyrillic: пиздопроёбина, Latin: pizdoproyobina",
      "target_type": "general"
    },
    {
      "word": "пиздопроёб",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "pizdoproyob"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck-up (compound mat from pizda+yebat'). Cyrillic: пиздопроёб, Latin: pizdoproyob",
      "target_type": "individual"
    },
    {
      "word": "пиздострадалец",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "pizdostradalet"
      ],
      "case_sensitive": false,
      "context_notes": "Pussy sufferer (from pizda). Cyrillic: пиздострадалец, Latin: pizdostradalet",
      "target_type": "individual"
    },
    {
      "word": "пиздун",
      "severity": 4,
      "categories": [
        "mat_system",
        "derogatory"
      ],
      "variations": [
        "pizdun"
      ],
      "case_sensitive": false,
      "context_notes": "Liar (from pizda). Cyrillic: пиздун, Latin: pizdun",
      "target_type": "individual"
    },
    {
      "word": "пиздылина",
      "severity": 4,
      "categories": [
        "mat_system",
        "derogatory"
      ],
      "variations": [
        "pizdylina"
      ],
      "case_sensitive": false,
      "context_notes": "Pussy-related insult (from pizda). Cyrillic: пиздылина, Latin: pizdylina",
      "target_type": "individual"
    },
    {
      "word": "писька",
      "severity": 1,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "pis'ka"
      ],
      "case_sensitive": false,
      "context_notes": "Pussy (childish form of pizda). Cyrillic: писька, Latin: pis'ka",
      "target_type": "general"
    },
    {
      "word": "писюн",
      "severity": 1,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "pisyun"
      ],
      "case_sensitive": false,
      "context_notes": "Penis (childish). Cyrillic: писюн, Latin: pisyun",
      "target_type": "general"
    },
    {
      "word": "поебень",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "poeben'"
      ],
      "case_sensitive": false,
      "context_notes": "Fucked up situation (from yebat'). Cyrillic: поебень, Latin: poeben'",
      "target_type": "general"
    },
    {
      "word": "похуй",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "pohuy"
      ],
      "case_sensitive": false,
      "context_notes": "Don't give a fuck (from khuy). Cyrillic: похуй, Latin: pohuy",
      "target_type": "general"
    },
    {
      "word": "похуист",
      "severity": 4,
      "categories": [
        "mat_system",
        "derogatory"
      ],
      "variations": [
        "pohuyist"
      ],
      "case_sensitive": false,
      "context_notes": "Person who doesn't give a fuck (from khuy). Cyrillic: похуист, Latin: pohuyist",
      "target_type": "individual"
    },
    {
      "word": "припиздень",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "pripizden'"
      ],
      "case_sensitive": false,
      "context_notes": "To arrive (vulgar, from pizda). Cyrillic: припиздень, Latin: pripizden'",
      "target_type": "general"
    },
    {
      "word": "присрать",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "prisrat'"
      ],
      "case_sensitive": false,
      "context_notes": "To shit on. Cyrillic: присрать, Latin: prisrat'",
      "target_type": "general"
    },
    {
      "word": "проебать",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "proebat'"
      ],
      "case_sensitive": false,
      "context_notes": "To fuck up/lose (from yebat'). Cyrillic: проебать, Latin: proebat'",
      "target_type": "general"
    },
    {
      "word": "проебаться",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "proebat'sya"
      ],
      "case_sensitive": false,
      "context_notes": "To screw up (from yebat'). Cyrillic: проебаться, Latin: proebat'sya",
      "target_type": "general"
    },
    {
      "word": "промудобладскся",
      "severity": 3,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "promudobladsksya"
      ],
      "case_sensitive": false,
      "context_notes": "To fuck around (from muda). Cyrillic: промудобладскся, Latin: promudobladsksya",
      "target_type": "general"
    },
    {
      "word": "пропиздеть",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "propizdet'"
      ],
      "case_sensitive": false,
      "context_notes": "To miss/lose (from pizda). Cyrillic: пропиздеть, Latin: propizdet'",
      "target_type": "general"
    },
    {
      "word": "пропездолоч",
      "severity": 4,
      "categories": [
        "mat_system",
        "derogatory"
      ],
      "variations": [
        "propezdoloch"
      ],
      "case_sensitive": false,
      "context_notes": "Fucking bastard (from pizda). Cyrillic: пропездолоч, Latin: propezdoloch",
      "target_type": "individual"
    },
    {
      "word": "просрать",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "prosrat'"
      ],
      "case_sensitive": false,
      "context_notes": "To shit away/lose. Cyrillic: просрать, Latin: prosrat'",
      "target_type": "general"
    },
    {
      "word": "пёзда",
      "severity": 4,
      "categories": [
        "mat_system",
        "sexual",
        "anatomical"
      ],
      "variations": [
        "pyozda"
      ],
      "case_sensitive": false,
      "context_notes": "Variant of pizda. Cyrillic: пёзда, Latin: pyozda",
      "target_type": "general"
    },
    {
      "word": "распиздяй",
      "severity": 4,
      "categories": [
        "mat_system",
        "derogatory"
      ],
      "variations": [
        "raspizdjay"
      ],
      "case_sensitive": false,
      "context_notes": "Sloppy person (from pizda). Cyrillic: распиздяй, Latin: raspizdjay",
      "target_type": "individual"
    },
    {
      "word": "распиздяйство",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "raspizdjaystvo"
      ],
      "case_sensitive": false,
      "context_notes": "Sloppiness (from pizda). Cyrillic: распиздяйство, Latin: raspizdjaystvo",
      "target_type": "general"
    },
    {
      "word": "распиздатый",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "raspizdatyj"
      ],
      "case_sensitive": false,
      "context_notes": "Worn out/loose (from pizda). Cyrillic: распиздатый, Latin: raspizdatyj",
      "target_type": "general"
    },
    {
      "word": "расперделся",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "rasperdelsya"
      ],
      "case_sensitive": false,
      "context_notes": "Spread out (from perdet'). Cyrillic: расперделся, Latin: rasperdelsya",
      "target_type": "general"
    },
    {
      "word": "сволота",
      "severity": 3,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "svolota"
      ],
      "case_sensitive": false,
      "context_notes": "Scum (collective). Cyrillic: сволота, Latin: svolota",
      "target_type": "general"
    },
    {
      "word": "срака",
      "severity": 2,
      "categories": [
        "anatomical"
      ],
      "variations": [
        "sraka"
      ],
      "case_sensitive": false,
      "context_notes": "Ass (vulgar). Cyrillic: срака, Latin: sraka",
      "target_type": "general"
    },
    {
      "word": "срать",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "srat'"
      ],
      "case_sensitive": false,
      "context_notes": "To shit. Cyrillic: срать, Latin: srat'",
      "target_type": "general"
    },
    {
      "word": "сратье",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "sratye"
      ],
      "case_sensitive": false,
      "context_notes": "Shitting. Cyrillic: сратье, Latin: sratye",
      "target_type": "general"
    },
    {
      "word": "ссать",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "ssat'"
      ],
      "case_sensitive": false,
      "context_notes": "To piss. Cyrillic: ссать, Latin: ssat'",
      "target_type": "general"
    },
    {
      "word": "стерва",
      "severity": 3,
      "categories": [
        "derogatory",
        "female_specific"
      ],
      "variations": [
        "sterva"
      ],
      "case_sensitive": false,
      "context_notes": "Bitch/shrew. Cyrillic: стерва, Latin: sterva",
      "target_type": "individual"
    },
    {
      "word": "стервятник",
      "severity": 3,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "stervyatnik"
      ],
      "case_sensitive": false,
      "context_notes": "Vulture/bastard. Cyrillic: стервятник, Latin: stervyatnik",
      "target_type": "individual"
    },
    {
      "word": "сучара",
      "severity": 3,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "suchara"
      ],
      "case_sensitive": false,
      "context_notes": "Bitch (colloquial). Cyrillic: сучара, Latin: suchara",
      "target_type": "individual"
    },
    {
      "word": "сучонка",
      "severity": 3,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "suchonka"
      ],
      "case_sensitive": false,
      "context_notes": "Little bitch (regional). Cyrillic: сучонка, Latin: suchonka",
      "target_type": "individual"
    },
    {
      "word": "трахать",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "trahat'"
      ],
      "case_sensitive": false,
      "context_notes": "To fuck (less vulgar than yebat'). Cyrillic: трахать, Latin: trahat'",
      "target_type": "general"
    },
    {
      "word": "трахаться",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "trahat'sya"
      ],
      "case_sensitive": false,
      "context_notes": "To fuck (reflexive). Cyrillic: трахаться, Latin: trahat'sya",
      "target_type": "general"
    },
    {
      "word": "убить",
      "severity": 2,
      "categories": [
        "violence"
      ],
      "variations": [
        "ubit'"
      ],
      "case_sensitive": false,
      "context_notes": "To kill (can be vulgar in context). Cyrillic: убить, Latin: ubit'",
      "target_type": "individual"
    },
    {
      "word": "ублюдок",
      "severity": 3,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "ublyudok"
      ],
      "case_sensitive": false,
      "context_notes": "Bastard/mongrel. Cyrillic: ублюдок, Latin: ublyudok",
      "target_type": "individual"
    },
    {
      "word": "уебан",
      "severity": 4,
      "categories": [
        "mat_system",
        "derogatory"
      ],
      "variations": [
        "ujeban"
      ],
      "case_sensitive": false,
      "context_notes": "Fucker/idiot (from yebat'). Cyrillic: уебан, Latin: ujeban",
      "target_type": "individual"
    },
    {
      "word": "уёбище",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "uyobishche"
      ],
      "case_sensitive": false,
      "context_notes": "Fucking mess (from yebat'). Cyrillic: уёбище, Latin: uyobishche",
      "target_type": "general"
    },
    {
      "word": "уебок",
      "severity": 4,
      "categories": [
        "mat_system",
        "derogatory"
      ],
      "variations": [
        "ujebok"
      ],
      "case_sensitive": false,
      "context_notes": "Fucker (from yebat'). Cyrillic: уебок, Latin: ujebok",
      "target_type": "individual"
    },
    {
      "word": "уродина",
      "severity": 2,
      "categories": [
        "derogatory",
        "appearance"
      ],
      "variations": [
        "urodina"
      ],
      "case_sensitive": false,
      "context_notes": "Big freak (augmentative). Cyrillic: уродина, Latin: urodina",
      "target_type": "individual"
    },
    {
      "word": "уродище",
      "severity": 2,
      "categories": [
        "derogatory",
        "appearance"
      ],
      "variations": [
        "urodishche"
      ],
      "case_sensitive": false,
      "context_notes": "Monster (augmentative). Cyrillic: уродище, Latin: urodishche",
      "target_type": "individual"
    },
    {
      "word": "хер",
      "severity": 3,
      "categories": [
        "mat_system",
        "sexual",
        "anatomical"
      ],
      "variations": [
        "her"
      ],
      "case_sensitive": false,
      "context_notes": "Dick (euphemistic form of khuy). Cyrillic: хер, Latin: her",
      "target_type": "general"
    },
    {
      "word": "херня",
      "severity": 3,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "hernya"
      ],
      "case_sensitive": false,
      "context_notes": "Bullshit/crap (from khuy). Cyrillic: херня, Latin: hernya",
      "target_type": "general"
    },
    {
      "word": "херов",
      "severity": 3,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "herov"
      ],
      "case_sensitive": false,
      "context_notes": "Dick's/shitty (from khuy). Cyrillic: херов, Latin: herov",
      "target_type": "general"
    },
    {
      "word": "хрен",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "hren"
      ],
      "case_sensitive": false,
      "context_notes": "Horseradish/dick (mild euphemism for khuy). Cyrillic: хрен, Latin: hren",
      "target_type": "general"
    },
    {
      "word": "хуеплёт",
      "severity": 4,
      "categories": [
        "mat_system",
        "derogatory"
      ],
      "variations": [
        "hueplyot"
      ],
      "case_sensitive": false,
      "context_notes": "Bullshitter (from khuy). Cyrillic: хуеплёт, Latin: hueplyot",
      "target_type": "individual"
    },
    {
      "word": "хуесос",
      "severity": 4,
      "categories": [
        "mat_system",
        "sexual"
      ],
      "variations": [
        "huesos"
      ],
      "case_sensitive": false,
      "context_notes": "Cocksucker (from khuy). Cyrillic: хуесос, Latin: huesos",
      "target_type": "individual"
    },
    {
      "word": "хуета",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "hueta"
      ],
      "case_sensitive": false,
      "context_notes": "Bullshit (from khuy). Cyrillic: хуета, Latin: hueta",
      "target_type": "general"
    },
    {
      "word": "хуёво",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "huyovo"
      ],
      "case_sensitive": false,
      "context_notes": "Shitty/bad (from khuy). Cyrillic: хуёво, Latin: huyovo",
      "target_type": "general"
    },
    {
      "word": "хуёвый",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "huyovyi"
      ],
      "case_sensitive": false,
      "context_notes": "Shitty/bad (from khuy). Cyrillic: хуёвый, Latin: huyovyi",
      "target_type": "general"
    },
    {
      "word": "хуйло",
      "severity": 4,
      "categories": [
        "mat_system",
        "derogatory"
      ],
      "variations": [
        "huylo"
      ],
      "case_sensitive": false,
      "context_notes": "Dickhead (from khuy, political usage). Cyrillic: хуйло, Latin: huylo",
      "target_type": "individual"
    },
    {
      "word": "хуйня",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "huynya"
      ],
      "case_sensitive": false,
      "context_notes": "Bullshit/crap (from khuy). Cyrillic: хуйня, Latin: huynya",
      "target_type": "general"
    },
    {
      "word": "хуяк",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "huyak"
      ],
      "case_sensitive": false,
      "context_notes": "Bang/hit (from khuy). Cyrillic: хуяк, Latin: huyak",
      "target_type": "general"
    },
    {
      "word": "хуякать",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "huyakat'"
      ],
      "case_sensitive": false,
      "context_notes": "To hit/work hard (from khuy). Cyrillic: хуякать, Latin: huyakat'",
      "target_type": "general"
    },
    {
      "word": "цыган",
      "severity": 2,
      "categories": [
        "slurs"
      ],
      "variations": [
        "tsygan"
      ],
      "case_sensitive": false,
      "context_notes": "Gypsy (can be ethnic slur). Cyrillic: цыган, Latin: tsygan",
      "target_type": "individual"
    },
    {
      "word": "чёрт",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "chort"
      ],
      "case_sensitive": false,
      "context_notes": "Devil/damn (mild curse). Cyrillic: чёрт, Latin: chort",
      "target_type": "general"
    },
    {
      "word": "чмо",
      "severity": 2,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "chmo"
      ],
      "case_sensitive": false,
      "context_notes": "Loser/scum (prison slang). Cyrillic: чмо, Latin: chmo",
      "target_type": "individual"
    },
    {
      "word": "чмошник",
      "severity": 2,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "chmoshnik"
      ],
      "case_sensitive": false,
      "context_notes": "Lowlife (from chmo). Cyrillic: чмошник, Latin: chmoshnik",
      "target_type": "individual"
    },
    {
      "word": "чмырь",
      "severity": 2,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "chmyr'"
      ],
      "case_sensitive": false,
      "context_notes": "Scum (prison slang). Cyrillic: чмырь, Latin: chmyr'",
      "target_type": "individual"
    },
    {
      "word": "шалава",
      "severity": 3,
      "categories": [
        "sexual",
        "female_specific"
      ],
      "variations": [
        "shalava"
      ],
      "case_sensitive": false,
      "context_notes": "Slut/whore. Cyrillic: шалава, Latin: shalava",
      "target_type": "individual"
    },
    {
      "word": "шлюшка",
      "severity": 3,
      "categories": [
        "sexual",
        "female_specific"
      ],
      "variations": [
        "shlyushka"
      ],
      "case_sensitive": false,
      "context_notes": "Little whore (diminutive). Cyrillic: шлюшка, Latin: shlyushka",
      "target_type": "individual"
    },
    {
      "word": "ебень",
      "severity": 4,
      "categories": [
        "mat_system"
      ],
      "variations": [
        "eben'"
      ],
      "case_sensitive": false,
      "context_notes": "Middle of nowhere (from yebat'). Cyrillic: ебень, Latin: eben'",
      "target_type": "general"
    },
    {
      "word": "хачик",
      "severity": 4,
      "categories": [
        "slurs",
        "hate_speech"
      ],
      "variations": [
        "hachik"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory for Caucasian peoples. Cyrillic: хачик, Latin: hachik",
      "target_type": "individual"
    },
    {
      "word": "хач",
      "severity": 4,
      "categories": [
        "slurs",
        "hate_speech"
      ],
      "variations": [
        "hach"
      ],
      "case_sensitive": false,
      "context_notes": "Caucasian slur (short form). Cyrillic: хач, Latin: hach",
      "target_type": "individual"
    },
    {
      "word": "чурка",
      "severity": 4,
      "categories": [
        "slurs",
        "hate_speech"
      ],
      "variations": [
        "churka"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory for Central Asian peoples. Cyrillic: чурка, Latin: churka",
      "target_type": "individual"
    },
    {
      "word": "черножопый",
      "severity": 4,
      "categories": [
        "slurs",
        "hate_speech"
      ],
      "variations": [
        "chernozhopyi"
      ],
      "case_sensitive": false,
      "context_notes": "Black-assed (racist slur). Cyrillic: черножопый, Latin: chernozhopyi",
      "target_type": "individual"
    },
    {
      "word": "чучмек",
      "severity": 4,
      "categories": [
        "slurs",
        "hate_speech"
      ],
      "variations": [
        "chuchmek"
      ],
      "case_sensitive": false,
      "context_notes": "Central Asian slur. Cyrillic: чучмек, Latin: chuchmek",
      "target_type": "individual"
    },
    {
      "word": "узбек",
      "severity": 2,
      "categories": [
        "slurs"
      ],
      "variations": [
        "uzbek"
      ],
      "case_sensitive": false,
      "context_notes": "Can be neutral or slur depending on context. Cyrillic: узбек, Latin: uzbek",
      "target_type": "individual"
    },
    {
      "word": "жид",
      "severity": 4,
      "categories": [
        "slurs",
        "hate_speech"
      ],
      "variations": [
        "zhid"
      ],
      "case_sensitive": false,
      "context_notes": "Kike/Yid (anti-Semitic slur). Cyrillic: жид, Latin: zhid",
      "target_type": "individual"
    },
    {
      "word": "москаль",
      "severity": 2,
      "categories": [
        "slurs"
      ],
      "variations": [
        "moskal'"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory for Russians (used by Ukrainians). Cyrillic: москаль, Latin: moskal'",
      "target_type": "individual"
    },
    {
      "word": "хохол",
      "severity": 2,
      "categories": [
        "slurs"
      ],
      "variations": [
        "hohol"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory for Ukrainians (used by Russians). Cyrillic: хохол, Latin: hohol",
      "target_type": "individual"
    },
    {
      "word": "пидор",
      "severity": 3,
      "categories": [
        "slurs",
        "hate_speech"
      ],
      "variations": [
        "pidor"
      ],
      "case_sensitive": false,
      "context_notes": "Faggot (homophobic slur). Cyrillic: пидор, Latin: pidor",
      "target_type": "individual"
    },
    {
      "word": "пидорас",
      "severity": 3,
      "categories": [
        "slurs",
        "hate_speech"
      ],
      "variations": [
        "pidoras"
      ],
      "case_sensitive": false,
      "context_notes": "Faggot (augmentative). Cyrillic: пидорас, Latin: pidoras",
      "target_type": "individual"
    },
    {
      "word": "пидорасня",
      "severity": 4,
      "categories": [
        "slurs",
        "hate_speech"
      ],
      "variations": [
        "pidorasnya"
      ],
      "case_sensitive": false,
      "context_notes": "Faggotry (collective). Cyrillic: пидорасня, Latin: pidorasnya",
      "target_type": "group"
    },
    {
      "word": "педрила",
      "severity": 3,
      "categories": [
        "slurs",
        "hate_speech"
      ],
      "variations": [
        "pedrila"
      ],
      "case_sensitive": false,
      "context_notes": "Faggot (variant). Cyrillic: педрила, Latin: pedrila",
      "target_type": "individual"
    },
    {
      "word": "гомик",
      "severity": 2,
      "categories": [
        "slurs"
      ],
      "variations": [
        "gomik"
      ],
      "case_sensitive": false,
      "context_notes": "Homo (diminutive, derogatory). Cyrillic: гомик, Latin: gomik",
      "target_type": "individual"
    },
    {
      "word": "гомосек",
      "severity": 2,
      "categories": [
        "slurs"
      ],
      "variations": [
        "gomosek"
      ],
      "case_sensitive": false,
      "context_notes": "Homosexual (derogatory). Cyrillic: гомосек, Latin: gomosek",
      "target_type": "individual"
    },
    {
      "word": "петух",
      "severity": 3,
      "categories": [
        "slurs"
      ],
      "variations": [
        "petuh"
      ],
      "case_sensitive": false,
      "context_notes": "Rooster/prison bitch (prison slang, homophobic). Cyrillic: петух, Latin: petuh",
      "target_type": "individual"
    },
    {
      "word": "лесбиянка",
      "severity": 1,
      "categories": [
        "slurs"
      ],
      "variations": [
        "lesbianka"
      ],
      "case_sensitive": false,
      "context_notes": "Lesbian (can be neutral or slur). Cyrillic: лесбиянка, Latin: lesbianka",
      "target_type": "individual"
    },
    {
      "word": "вор",
      "severity": 2,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "vor"
      ],
      "case_sensitive": false,
      "context_notes": "Thief (neutral, but prison context). Cyrillic: вор, Latin: vor",
      "target_type": "individual"
    },
    {
      "word": "зек",
      "severity": 2,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "zek"
      ],
      "case_sensitive": false,
      "context_notes": "Convict (from Soviet Gulag). Cyrillic: зек, Latin: zek",
      "target_type": "individual"
    },
    {
      "word": "мусор",
      "severity": 2,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "musor"
      ],
      "case_sensitive": false,
      "context_notes": "Trash/cop (derogatory). Cyrillic: мусор, Latin: musor",
      "target_type": "individual"
    },
    {
      "word": "легавый",
      "severity": 2,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "legavyi"
      ],
      "case_sensitive": false,
      "context_notes": "Cop (derogatory, literally 'hound dog'). Cyrillic: легавый, Latin: legavyi",
      "target_type": "individual"
    },
    {
      "word": "фраер",
      "severity": 2,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "fraer"
      ],
      "case_sensitive": false,
      "context_notes": "Sucker/civilian (prison slang). Cyrillic: фраер, Latin: fraer",
      "target_type": "individual"
    },
    {
      "word": "шестёрка",
      "severity": 2,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "shestyorka"
      ],
      "case_sensitive": false,
      "context_notes": "Errand boy (criminal hierarchy). Cyrillic: шестёрка, Latin: shestyorka",
      "target_type": "individual"
    },
    {
      "word": "чушка",
      "severity": 2,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "chushka"
      ],
      "case_sensitive": false,
      "context_notes": "Pig/filthy person. Cyrillic: чушка, Latin: chushka",
      "target_type": "individual"
    },
    {
      "word": "жаба",
      "severity": 1,
      "categories": [
        "derogatory",
        "female_specific"
      ],
      "variations": [
        "zhaba"
      ],
      "case_sensitive": false,
      "context_notes": "Toad/ugly woman. Cyrillic: жаба, Latin: zhaba",
      "target_type": "individual"
    },
    {
      "word": "кабан",
      "severity": 2,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "kaban"
      ],
      "case_sensitive": false,
      "context_notes": "Boar/fat man. Cyrillic: кабан, Latin: kaban",
      "target_type": "individual"
    },
    {
      "word": "кобыла",
      "severity": 2,
      "categories": [
        "derogatory",
        "female_specific"
      ],
      "variations": [
        "kobyla"
      ],
      "case_sensitive": false,
      "context_notes": "Mare/big woman. Cyrillic: кобыла, Latin: kobyla",
      "target_type": "individual"
    },
    {
      "word": "корова",
      "severity": 1,
      "categories": [
        "derogatory",
        "female_specific"
      ],
      "variations": [
        "korova"
      ],
      "case_sensitive": false,
      "context_notes": "Cow/fat woman. Cyrillic: корова, Latin: korova",
      "target_type": "individual"
    },
    {
      "word": "лох",
      "severity": 2,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "loh"
      ],
      "case_sensitive": false,
      "context_notes": "Sucker/loser. Cyrillic: лох, Latin: loh",
      "target_type": "individual"
    },
    {
      "word": "мразь",
      "severity": 3,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "mraz'"
      ],
      "case_sensitive": false,
      "context_notes": "Scum/vermin. Cyrillic: мразь, Latin: mraz'",
      "target_type": "individual"
    },
    {
      "word": "мымра",
      "severity": 2,
      "categories": [
        "derogatory",
        "female_specific"
      ],
      "variations": [
        "mymra"
      ],
      "case_sensitive": false,
      "context_notes": "Ugly old woman. Cyrillic: мымра, Latin: mymra",
      "target_type": "individual"
    },
    {
      "word": "тварь",
      "severity": 3,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "tvar'"
      ],
      "case_sensitive": false,
      "context_notes": "Creature/bastard. Cyrillic: тварь, Latin: tvar'",
      "target_type": "individual"
    },
    {
      "word": "ублюдина",
      "severity": 3,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "ublyudina"
      ],
      "case_sensitive": false,
      "context_notes": "Big bastard (augmentative). Cyrillic: ублюдина, Latin: ublyudina",
      "target_type": "individual"
    },
    {
      "word": "ухарь",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [
        "uhar'"
      ],
      "case_sensitive": false,
      "context_notes": "Daredevil (can be negative). Cyrillic: ухарь, Latin: uhar'",
      "target_type": "individual"
    }
  ]
} as const

export type RUType = typeof RU
